var map = {
	"./account-add.svg": 19824,
	"./account-admin.svg": 76360,
	"./account-edit.svg": 84007,
	"./account.svg": 53434,
	"./admin.svg": 57654,
	"./after-sales.svg": 18426,
	"./ai.svg": 22415,
	"./aigrow.svg": 28454,
	"./album.svg": 7726,
	"./announcement.svg": 76408,
	"./application.svg": 32041,
	"./atom.svg": 85894,
	"./attachment.svg": 34,
	"./back.svg": 61348,
	"./bell.svg": 98646,
	"./bill.svg": 73458,
	"./block.svg": 38916,
	"./business.svg": 79639,
	"./category.svg": 85501,
	"./close.svg": 71019,
	"./codesnippet.svg": 43449,
	"./crontask.svg": 79546,
	"./dashboard.svg": 84847,
	"./device.svg": 1659,
	"./device2.svg": 16099,
	"./device_camera.svg": 61027,
	"./device_controller.svg": 10878,
	"./device_es.svg": 24150,
	"./device_fertilizer.svg": 10024,
	"./device_irrigation.svg": 13546,
	"./device_other.svg": 63848,
	"./device_sensor.svg": 58396,
	"./discount.svg": 7484,
	"./document.svg": 58058,
	"./eco.svg": 95020,
	"./electric.svg": 31656,
	"./email.svg": 65891,
	"./enterprise.svg": 18408,
	"./expand.svg": 59185,
	"./file-bucket.svg": 2498,
	"./file.svg": 85855,
	"./folder.svg": 16477,
	"./goods.svg": 58633,
	"./group.svg": 76350,
	"./headset.svg": 71173,
	"./history.svg": 72175,
	"./home.svg": 52936,
	"./icons.svg": 72585,
	"./index.svg": 17179,
	"./indicator.svg": 98768,
	"./irrigation.svg": 96425,
	"./lock.svg": 35716,
	"./log.svg": 98169,
	"./log1.svg": 84282,
	"./log2.svg": 99369,
	"./menu.svg": 56412,
	"./menu1.svg": 81381,
	"./message.svg": 4622,
	"./misc.svg": 15901,
	"./my-workflows.svg": 31986,
	"./nodetemplate.svg": 65347,
	"./order.svg": 84999,
	"./organization.svg": 86508,
	"./page.svg": 39808,
	"./phmsg.svg": 62844,
	"./phone-call.svg": 56508,
	"./plant.svg": 83472,
	"./platform.svg": 32436,
	"./preset.svg": 12300,
	"./price.svg": 17908,
	"./private.svg": 99730,
	"./product.svg": 92958,
	"./protection.svg": 77628,
	"./read.svg": 83917,
	"./redis.svg": 82250,
	"./resource-video.svg": 24663,
	"./resource.svg": 37141,
	"./send.svg": 19879,
	"./sensor.svg": 52255,
	"./service.svg": 24298,
	"./setting.svg": 46587,
	"./signal.svg": 6777,
	"./sim.svg": 39190,
	"./sms.svg": 94532,
	"./statement.svg": 96208,
	"./stock-record.svg": 52377,
	"./system.svg": 13070,
	"./task.svg": 39062,
	"./template-email.svg": 9940,
	"./template.svg": 9907,
	"./terminal.svg": 29013,
	"./test.svg": 89773,
	"./timezone.svg": 56092,
	"./titan.svg": 50189,
	"./titanconf.svg": 49851,
	"./todo.svg": 22729,
	"./types.svg": 39648,
	"./unread.svg": 85808,
	"./upload.svg": 10426,
	"./user.svg": 65576,
	"./users.svg": 35387,
	"./wifi.svg": 69578,
	"./workflows-stat.svg": 13872,
	"./workflows.svg": 46097,
	"./www.svg": 36902,
	"./wx.svg": 9252,
	"./wxmsg.svg": 50487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80638;